import { gqlQuery } from '@hapana/shared/web/services/requests.service'

import {
  siteEnableTanningFeaturesQuery,
  siteTanningMaintenanceEmailQuery,
} from './graphql/site.queries'

export const getSiteEnableTanningFeatures = gqlQuery({
  key: 'SITE_ENABLE_TANNING_FEATURES',
  query: siteEnableTanningFeaturesQuery,
})

export const getSiteTanningMaintenanceEmail = gqlQuery({
  key: 'SITE_TANNING_MAINTENANCE_EMAIL',
  query: siteTanningMaintenanceEmailQuery,
})
